import { useEffect, useRef } from "preact/hooks";
import type { PageVisit } from "@pankagent/shared";

const MAX_RECENT_PAGES = 5;

/**
 * Hook to track page visits for context enrichment
 * Returns the list of recent pages visited
 */
export function usePageTracking() {
  const recentPagesRef = useRef<PageVisit[]>([]);

  const trackPageVisit = () => {
    const visit: PageVisit = {
      url: window.location.href,
      title: document.title,
      timestamp: Date.now(),
    };

    const recentPages = recentPagesRef.current;

    // Avoid duplicates
    if (
      recentPages.length === 0 ||
      recentPages[recentPages.length - 1]?.url !== visit.url
    ) {
      recentPages.push(visit);
      if (recentPages.length > MAX_RECENT_PAGES) {
        recentPages.shift();
      }
    }
  };

  useEffect(() => {
    // Track initial page
    trackPageVisit();

    // Track page changes (SPA navigation)
    const handlePopState = () => trackPageVisit();
    window.addEventListener("popstate", handlePopState);

    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const getRecentPages = (count = 3): PageVisit[] => {
    return recentPagesRef.current.slice(-count);
  };

  return { getRecentPages, trackPageVisit };
}
